import MainIconStage_1 from '../../icons/svg/custom-client-offer-stage-1-main-icon.svg'
import MainIconStage_2 from '../../icons/svg/custom-client-offer-stage-2-main-icon.svg'
import MainIconStage_3 from '../../icons/svg/custom-client-offer-stage-3-main-icon.svg'


// ============================================= INTERFACES =============================================
export interface ICustomClientSingleOffer { 
   offerId: number;
   offerName: CUSTOM_CLIENT_OFFERS_NAMES;
   headingTextPath: string;
   descriptionTextPath: string;
   offerImageSrc: string;
}

export type ICustomClientOffersConfig = Record<CUSTOM_CLIENT_OFFERS_NAMES, ICustomClientSingleOffer>

// ========================================================================================================

export enum CUSTOM_CLIENT_OFFERS_NAMES {
   LOWEST_OFFER = "LOWEST_OFFER",
   AVERAGE_OFFER = "AVERAGE_OFFER",
   HIGHEST_OFFER = "HIGHEST_OFFER",
}

export const customClientOffersConfig: ICustomClientOffersConfig = {
   [CUSTOM_CLIENT_OFFERS_NAMES.LOWEST_OFFER]: {
      offerId: 1,
      offerName: CUSTOM_CLIENT_OFFERS_NAMES.LOWEST_OFFER,
      headingTextPath: "customClientOfferPage.customLowestOffer.heading",
      descriptionTextPath: "customClientOfferPage.customLowestOffer.description",
      offerImageSrc: MainIconStage_1,
   },
   [CUSTOM_CLIENT_OFFERS_NAMES.AVERAGE_OFFER]: {
      offerId: 2,
      offerName: CUSTOM_CLIENT_OFFERS_NAMES.AVERAGE_OFFER,
      headingTextPath: "customClientOfferPage.customAverageOffer.heading",
      descriptionTextPath: "customClientOfferPage.customAverageOffer.description",
      offerImageSrc: MainIconStage_2,
   },
   [CUSTOM_CLIENT_OFFERS_NAMES.HIGHEST_OFFER]: {
      offerId: 3,
      offerName: CUSTOM_CLIENT_OFFERS_NAMES.HIGHEST_OFFER,
      headingTextPath: "customClientOfferPage.customHigherOffer.heading",
      descriptionTextPath: "customClientOfferPage.customHigherOffer.description",
      offerImageSrc: MainIconStage_3,
   },
}


export const selectCustomClientOfferBasedOnLoanLimits = (requestedAmount: number | null, minimumLoanAmount: number | null, maximumLoanAmount: number | null): CUSTOM_CLIENT_OFFERS_NAMES => {
   if(minimumLoanAmount === null || maximumLoanAmount === null || requestedAmount === null) {
      console.error("Nie określono limitów pożyczki. Zwrócono domyślnie najniższą ofertę.");
      return CUSTOM_CLIENT_OFFERS_NAMES.LOWEST_OFFER
   }

   const range = maximumLoanAmount - minimumLoanAmount
   const segmentSize = range  / Object.keys(customClientOffersConfig).length
   const lowerBound = minimumLoanAmount + segmentSize
   const upperBound = minimumLoanAmount + (2 * segmentSize)

   if (requestedAmount < lowerBound) {
      return CUSTOM_CLIENT_OFFERS_NAMES.LOWEST_OFFER;
   } 
   else if (requestedAmount < upperBound) {
      return CUSTOM_CLIENT_OFFERS_NAMES.AVERAGE_OFFER;
   } 
   else {
      return CUSTOM_CLIENT_OFFERS_NAMES.HIGHEST_OFFER;
   }
}